import { render, staticRenderFns } from "./PermissionEdit.vue?vue&type=template&id=7b5917fa&scoped=true&"
import script from "./PermissionEdit.vue?vue&type=script&lang=js&"
export * from "./PermissionEdit.vue?vue&type=script&lang=js&"
import style0 from "./PermissionEdit.vue?vue&type=style&index=0&id=7b5917fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5917fa",
  null
  
)

export default component.exports